<script setup lang="ts">
import { inject, onBeforeUnmount, ref, watch } from 'vue';
import Icon from './Icon.vue';
const props = defineProps<{ open: boolean; title: string; description?: string; busy?: boolean }>();
const emit = defineEmits<{ close: [] }>();
const theme=inject('fuqi-account-theme',ref(document.documentElement.dataset.theme || 'account'));
function keyboard(event: KeyboardEvent) {
  if (!props.open) return;
  if (event.key === 'Escape' && !props.busy) emit('close');
}
watch(() => props.open, open => {
  if (open) { document.body.style.overflow = 'hidden'; document.addEventListener('keydown', keyboard); }
  else { document.body.style.overflow = ''; document.removeEventListener('keydown', keyboard); }
});
onBeforeUnmount(() => { document.body.style.overflow = ''; document.removeEventListener('keydown', keyboard); });
</script>
<template>
  <Teleport to="body"><div class="fuqi-account-root" :data-theme="theme"><Transition name="dialog"><div v-if="open" class="dialog-backdrop" @click.self="!busy && emit('close')">
    <section class="dialog-panel">
      <button class="icon-button dialog-close" :disabled="busy" @click="emit('close')"><Icon name="X" /></button>
      <header><h2>{{ title }}</h2><p v-if="description" class="muted">{{ description }}</p></header>
      <slot />
    </section>
  </div></Transition></div></Teleport>
</template>
